import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '../../api/api';
import { Order } from '../../types';

interface OrderState {
  orders: Order[];
  currentOrder: Order | null;
  loading: boolean;
}

export const createOrder = createAsyncThunk('order/create', async (data: any) => {
  const res = await api.post<Order>('/orders', data);
  return res.data;
});

export const updateOrderStatus = createAsyncThunk(
  'order/updateStatus',
  async ({ id, status }: { id: number; status: string }) => {
    const res = await api.put<Order>(`/orders/${id}/status`, { status });
    return res.data;
  }
);

export const addTips = createAsyncThunk(
  'order/addTips',
  async ({ id, tipForWaiter, tipForKitchen }: { id: number; tipForWaiter: number; tipForKitchen: number }) => {
    const res = await api.put<Order>(`/orders/${id}/tips`, { tipForWaiter, tipForKitchen });
    return res.data;
  }
);

const orderSlice = createSlice({
  name: 'order',
  initialState: { orders: [], currentOrder: null, loading: false } as OrderState,
  reducers: {
    setCurrentOrder(state, action: PayloadAction<Order | null>) {
      state.currentOrder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.fulfilled, (state, action) => {
        state.currentOrder = action.payload;
        state.orders.push(action.payload);
        state.loading = false;
      })
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrder.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.currentOrder = action.payload;
        const idx = state.orders.findIndex((o) => o.id === action.payload.id);
        if (idx !== -1) state.orders[idx] = action.payload;
      })
      .addCase(addTips.fulfilled, (state, action) => {
        state.currentOrder = action.payload;
      });
  },
});

export const { setCurrentOrder } = orderSlice.actions;
export default orderSlice.reducer;
